const PRODUCT_MISSION_DATA = [
  {
    id: "meetings",
    name: "Book 20 qualified customer meetings",
    short: "Business development",
    start: "Your ideal customer profile",
    destination: "20 qualified meetings on your calendar",
    count: "8 / 20",
    measure: "meetings booked",
    day: "Day 6",
    eta: "2 weeks",
    steps: ["Research", "Reach out", "Schedule", "Confirm"],
    appSequence: ["linkedin", "gmail", "googlecalendar", "hubspot"],
    document: "Customer meetings / Account brief",
    activity: [
      "Target accounts qualified",
      "Personalized conversations opened",
      "Meeting times coordinated",
      "CRM and calendar updated",
    ],
    summary:
      "Find the right customers, start relevant conversations, and turn interest into qualified meetings.",
    columns: ["Company", "Contact", "Stage", "Next step"],
    rows: [
      ["Meridian", "Alice Chen", "Meeting booked", "Wed, 10:00 AM"],
      ["Forma", "Marcus Reed", "Meeting booked", "Tue, 11:00 AM"],
      ["Daylight", "Sofia Patel", "Replied", "Coordinate a time"],
      ["Common Ground", "Noah Brooks", "Qualified", "Personalize outreach"],
      ["Orbit", "Maya Ellis", "Meeting booked", "Thu, 2:00 PM"],
    ],
  },
  {
    id: "hiring",
    name: "Hire 3 founding engineers",
    short: "Talent",
    start: "Your role and hiring criteria",
    destination: "3 founding engineers ready to start",
    count: "1 / 3",
    measure: "engineers hired",
    day: "Day 14",
    eta: "3 weeks",
    steps: ["Source", "Connect", "Interview", "Hire"],
    appSequence: ["linkedin", "gmail", "googlecalendar", "googlesheets"],
    document: "Founding engineering team / Hiring brief",
    sheetTitle: "Founding engineers / Hiring pipeline",
    activity: [
      "Role-matched engineers shortlisted",
      "Personalized introductions sent",
      "Technical interviews coordinated",
      "Signed offer and start date recorded",
    ],
    summary:
      "Build the founding team. Source against role-specific criteria, coordinate interviews, and keep every candidate moving.",
    columns: ["Candidate", "Specialty", "Stage", "Next step"],
    rows: [
      ["Jamie Park", "Infrastructure", "Hired", "Starts September 21"],
      ["Alex Morgan", "Distributed systems", "Interview", "Mon, 11:00 AM"],
      ["Taylor Chen", "Product engineering", "Interview", "Tue, 2:00 PM"],
      ["Jordan Rivera", "Developer tools", "Replied", "Coordinate a time"],
      ["Casey Brooks", "Applied AI", "Shortlisted", "Personalize outreach"],
    ],
  },
  {
    id: "growth",
    name: "Grow to 10,000 weekly active users",
    short: "Growth",
    start: "4,000 weekly active users",
    destination: "10,000 people using the product every week",
    count: "6,450 / 10k",
    measure: "weekly active users",
    day: "Day 19",
    eta: "4 weeks",
    steps: ["Diagnose", "Experiment", "Measure", "Scale"],
    appSequence: ["posthog", "notion", "googlesheets", "posthog"],
    document: "Growth / Activation and retention plan",
    sheetTitle: "Growth experiments / Weekly scorecard",
    activity: [
      "Activation and retention reviewed",
      "Onboarding and referral tests planned",
      "Experiment results compared",
      "Winning rollout prepared",
    ],
    summary:
      "Turn signups into habitual users. Find where people get stuck, improve first value, test referral loops, and bring users back. Scale what holds up in the data.",
    stageDetails: {
      1: {
        heading: "Make the first workflow stick",
        summary:
          "Test guided onboarding, team invitations, and referrals. Compare activation and returning users before widening any rollout.",
        note: "Primary measure: weekly active users. Target: 10,000.",
        items: [
          "Guided workflow / first-value test",
          "Team invitations / collaboration test",
          "Referral loop / capped-reward test",
        ],
      },
    },
    columns: ["Experiment", "Baseline", "Current", "Next step"],
    rows: [
      [
        "Guided first workflow",
        "42% activation",
        "56.8% activation",
        "Extend rollout",
      ],
      [
        "Team invitations",
        "12% invite rate",
        "19.6% invite rate",
        "Monitor cohort",
      ],
      [
        "Referral loop",
        "8.1% referral rate",
        "12.4% referral rate",
        "Test reward cap",
      ],
      ["Weekly digest", "31% return rate", "37% return rate", "Holdout check"],
      [
        "Dormant-user recovery",
        "18% reactivation",
        "23.5% reactivation",
        "Inspect retention",
      ],
    ],
    weeklyUsers: [
      { week: "Jul 27", users: 4000, returning: 2100 },
      { week: "Aug 3", users: 4320, returning: 2210 },
      { week: "Aug 10", users: 4790, returning: 2450 },
      { week: "Aug 17", users: 5280, returning: 2800 },
      { week: "Aug 24", users: 5860, returning: 3150 },
      { week: "Aug 31", users: 6450, returning: 3630 },
    ],
  },
  {
    id: "marketing",
    name: "Generate 500 qualified trial signups",
    short: "Marketing",
    start: "A product and its ideal audience",
    destination: "500 qualified trials across your channels",
    count: "218 / 500",
    measure: "qualified trials",
    day: "Day 11",
    eta: "3 weeks",
    steps: ["Position", "Launch", "Engage", "Attribute"],
    appSequence: ["notion", "googleads", "mailchimp", "googlesheets"],
    document: "Marketing / Qualified trial campaign",
    sheetTitle: "Campaign attribution / Qualified trials",
    activity: [
      "Audience and campaign brief prepared",
      "Paid search campaigns running",
      "Email engagement and trials measured",
      "Qualified trials attributed by channel",
    ],
    summary:
      "Find the message, launch the campaign, and improve the mix. Coordinate search, consented email, and useful content against one qualified-trial goal, within your delegated budget.",
    stageDetails: {
      0: {
        heading: "A faster path to first value",
        summary:
          "Reach operations teams with a concrete promise: connect a workspace and complete a first workflow. Count qualified trials, not clicks.",
        note: "500 qualified trials / $3,000 paid-media limit.",
        items: [
          "Search / high-intent workflow queries",
          "Email / opted-in operations teams",
          "Content / comparisons and onboarding guides",
        ],
      },
    },
    columns: ["Channel", "Qualified trials", "Spend", "Next step"],
    rows: [
      ["Paid search", "122", "$1,464", "Optimize creative"],
      ["Email", "64", "Owned channel", "Test subject line"],
      ["Organic content", "32", "Owned channel", "Publish comparison"],
      ["Total", "218 / 500", "$1,464", "Verify attribution"],
      ["Landing page", "Tracking verified", "No extra spend", "Test CTA"],
    ],
    campaigns: [
      { name: "Workflow automation", clicks: 1065, trials: 71, cost: 852 },
      { name: "Customer onboarding", clicks: 495, trials: 36, cost: 396 },
      { name: "Team productivity", clicks: 270, trials: 15, cost: 216 },
    ],
    paidMediaCap: 3000,
  },
  {
    id: "launch",
    name: "Launch the customer portal",
    short: "Product & engineering",
    start: "A release brief",
    destination: "A verified product launch",
    count: "18 / 22",
    measure: "launch checks",
    day: "Day 12",
    eta: "3 days",
    steps: ["Plan", "Build", "Verify", "Prepare rollout"],
    appSequence: ["notion", "linear", "github", "notion"],
    document: "Customer portal / Launch brief",
    activity: [
      "Release scope mapped",
      "Release work coordinated",
      "Merged code and checks verified",
      "Rollout readiness documented",
    ],
    summary:
      "A release, its checks, and the customer experience. Connected across every tool.",
    stageDetails: {
      0: {
        heading: "One release, clear ownership",
        summary:
          "Ship the customer portal with accessible onboarding, workspace permissions, and a monitored rollout.",
        note: "Launch only after all 22 release checks pass.",
        items: [
          "James / engineering and accessibility",
          "Regina / first-run customer walkthrough",
          "Erin / release scope and rollout",
        ],
      },
      3: {
        title: "Customer portal / Rollout readiness",
        status: "18 of 22 checks passed",
        heading: "Four checks before launch",
        summary:
          "Accessibility changes are merged and CI is green. Keep the release gated while the remaining rollout checks finish.",
        note: "18 / 22 checks passed. The portal is not live yet.",
        items: [
          "Verify production monitors",
          "Finish release notes and rollout checks",
          "Publish after the release gate clears",
        ],
      },
    },
    columns: ["Workstream", "Owner", "Progress", "Next step"],
    rows: [
      ["Customer portal", "Erin", "82%", "Final verification"],
      ["Accessibility", "James", "100%", "Complete"],
      ["Onboarding guide", "Regina", "100%", "Published"],
      ["Release notes", "Simon", "90%", "Final checks"],
      ["Rollout monitoring", "James", "60%", "Prepare monitors"],
    ],
  },
  {
    id: "customers",
    name: "Activate 24 customer workspaces",
    short: "Customer experience",
    start: "24 new customers",
    destination: "Every customer reaches first value",
    count: "18 / 24",
    measure: "workspaces activated",
    day: "Day 8",
    eta: "5 days",
    steps: ["Assess", "Unblock", "Verify", "Follow through"],
    appSequence: ["notion", "intercom", "googlesheets", "notion"],
    sheetTitle: "Customer activation tracker",
    document: "New customer / First-value guide",
    activity: [
      "Customer goals captured",
      "Import issue resolved",
      "Customer activation recorded",
      "Success handoffs prepared",
    ],
    summary:
      "Setup, support, and follow-through. Every customer gets a path to first value.",
    stageDetails: {
      0: {
        heading: "From signup to a working workspace",
        summary:
          "For each new customer, confirm the goal, import their records, and connect a first workflow. Resolve blockers in the same conversation.",
        note: "First value = records imported + first workflow completed.",
        items: [
          "Northstar / complete the customer import",
          "Meridian / verify imported records",
          "Forma / connect the first workflow",
        ],
      },
      3: {
        title: "Customer success / Activation handoff",
        status: "18 of 24 activated",
        heading: "The next step for every customer",
        summary:
          "Northstar has reached first value. Keep the remaining six workspaces moving and schedule follow-through for activated teams.",
        note: "18 / 24 workspaces activated. Six still in onboarding.",
        items: [
          "Northstar / success handoff attached",
          "Meridian / verify records with Simon",
          "Forma / first workflow with James",
        ],
      },
    },
    columns: ["Customer", "Owner", "Milestone", "Next step"],
    rows: [
      ["Northstar", "Regina", "Activated", "Success handoff"],
      ["Meridian", "Simon", "Importing", "Verify records"],
      ["Common Ground", "Regina", "Activated", "Check in Friday"],
      ["Forma", "James", "Connected", "First workflow"],
      ["Daylight", "Simon", "Activated", "Success handoff"],
    ],
  },
  {
    id: "operations",
    name: "Get the company ready for Monday",
    short: "Company operations",
    start: "A weekly mandate",
    destination: "A company ready for Monday",
    count: "31 / 34",
    measure: "tasks complete",
    day: "Week 3",
    eta: "2 days",
    steps: ["Reconcile", "Gather evidence", "Verify", "Report"],
    appSequence: ["googlesheets", "googledrive", "googlesheets", "notion"],
    sheetTitle: "Company operations / Weekly tracker",
    document: "Weekly operating brief",
    activity: [
      "Company records reconciled",
      "Vendor and access evidence gathered",
      "Completed work checked against evidence",
      "Operating brief assembled",
    ],
    summary:
      "Records, vendors, access, and priorities. The operating details keep moving.",
    evidenceFiles: [
      "Access audit / Verification log",
      "Vendor renewals / Terms comparison",
      "Weekly priorities / Team commitments",
      "Tool reconciliation / Account register",
      "Monday readiness / Open items",
    ],
    stageDetails: {
      2: {
        sheetTitle: "Company operations / Evidence checks",
        columns: ["Workstream", "Evidence", "Status", "Next step"],
        rows: [
          ["Access audit", "Verification log", "Verified", "Complete"],
          ["Vendor renewals", "Terms comparison", "Open", "Resolve terms"],
          ["Weekly priorities", "Team commitments", "Verified", "Complete"],
          ["Tool reconciliation", "Account register", "Verified", "Complete"],
          [
            "Monday readiness",
            "31 / 34 complete",
            "3 open items",
            "Finish before Monday",
          ],
        ],
      },
      3: {
        status: "31 of 34 complete",
        heading: "Monday readiness, with evidence",
        summary:
          "Access, tools, and team priorities are reconciled. Three items remain: vendor terms, a renewal decision, and final brief checks.",
        note: "31 / 34 tasks complete. Owners are assigned to the rest.",
        items: [
          "Simon / resolve vendor terms",
          "Erin / review the renewal exception",
          "Erin / finish operating brief checks",
        ],
      },
    },
    columns: ["Workstream", "Owner", "Status", "Next step"],
    rows: [
      ["Access audit", "James", "Verified", "Complete"],
      ["Vendor renewals", "Simon", "In progress", "Compare terms"],
      ["Weekly priorities", "Erin", "Aligned", "Complete"],
      ["Tool reconciliation", "Simon", "Verified", "Complete"],
      ["Operating brief", "Erin", "In progress", "Final checks"],
    ],
  },
  {
    id: "market",
    name: "Deliver a launch-ready UK market plan",
    short: "Market expansion",
    start: "A new opportunity",
    destination: "A UK launch plan backed by customer evidence",
    count: "17 / 25",
    measure: "evidence checks",
    day: "Day 18",
    eta: "3 weeks",
    steps: ["Explore", "Validate", "Prepare", "Propose"],
    appSequence: ["notion", "googlesheets", "googledrive", "notion"],
    sheetTitle: "UK launch / Market comparison",
    document: "UK market launch / Research brief",
    activity: [
      "Market hypotheses mapped",
      "Customer interviews synthesized",
      "Operating requirements mapped",
      "Recommendation assembled",
    ],
    summary:
      "Customer evidence, market context, and operating requirements. A decision with substance.",
    evidenceFiles: [
      "UK customer interviews / Synthesis",
      "Market comparison / UK, Canada, Australia",
      "UK operating requirements / Support plan",
      "UK pilot / Launch criteria",
      "Evidence register / 17 of 25 checks",
    ],
    stageDetails: {
      0: {
        heading: "Where should Northstar expand next?",
        summary:
          "Compare the UK, Canada, and Australia. Test customer demand, first-value needs, and the operating effort behind each market.",
        note: "A launch recommendation must be backed by customer evidence.",
        items: [
          "UK / workflow consolidation",
          "Canada / self-serve onboarding",
          "Australia / distributed operations",
        ],
      },
      3: {
        title: "UK market / Pilot recommendation",
        status: "17 of 25 checks complete",
        heading: "Prioritize a UK pilot",
        summary:
          "Eight UK interviews point to workflow consolidation. Prepare a focused pilot, with local support and launch criteria documented.",
        note: "17 / 25 evidence checks complete. Validate eight before launch.",
        items: [
          "Start with the operations-team segment",
          "Confirm local support coverage",
          "Close remaining evidence gaps",
        ],
      },
    },
    columns: ["Market", "Customer need", "Evidence", "Readiness"],
    rows: [
      [
        "United Kingdom",
        "Workflow consolidation",
        "8 interviews",
        "Validation",
      ],
      ["Canada", "Self-serve onboarding", "6 interviews", "Research"],
      ["Australia", "Distributed operations", "5 interviews", "Research"],
      ["Operating requirements", "Local support", "Mapped", "Verified"],
      [
        "Launch recommendation",
        "Priority segment",
        "17 / 25 checks",
        "In progress",
      ],
    ],
  },
];

// The route is the source of truth for both playback and first-use tab order.
export const PRODUCT_MISSIONS = PRODUCT_MISSION_DATA.map((mission) => ({
  ...mission,
  initialStage: 0,
  apps: [...new Set(mission.appSequence)],
}));

export const DEMO_APPS = {
  posthog: {
    name: "PostHog",
    color: "#f5b535",
    iconColor: "#202020",
    domain: "us.posthog.com",
    path: "project / northstar / insights / weekly-active-users",
  },
  googleads: {
    name: "Google Ads",
    color: "#4285f4",
    domain: "ads.google.com",
    path: "aw / campaigns / qualified-trials",
  },
  mailchimp: {
    name: "Mailchimp",
    color: "#ffe01b",
    iconColor: "#202020",
    domain: "admin.mailchimp.com",
    path: "campaigns / northstar / reports",
  },
  gmail: {
    name: "Gmail",
    color: "transparent",
    icon: "gmail.png",
    domain: "mail.google.com",
    path: "mail/u/0/#inbox",
  },
  linkedin: {
    name: "LinkedIn",
    color: "#0a66c2",
    domain: "linkedin.com",
    path: "search/results/people",
  },
  hubspot: {
    name: "HubSpot",
    color: "#ff5c35",
    domain: "app.hubspot.com",
    path: "contacts / qualified-meetings",
  },
  googlecalendar: {
    name: "Calendar",
    color: "transparent",
    icon: "googlecalendar.png",
    domain: "calendar.google.com",
    path: "calendar/u/0/r/week/2026/9/7",
  },
  linear: {
    name: "Linear",
    color: "#5e6ad2",
    domain: "linear.app",
    path: "northstar / customer-portal",
  },
  github: {
    name: "GitHub",
    color: "#24292f",
    domain: "github.com",
    path: "northstar / customer-portal / checks",
  },
  notion: {
    name: "Notion",
    color: "#202020",
    domain: "notion.so",
    path: "northstar / workspace",
  },
  intercom: {
    name: "Intercom",
    color: "#286efa",
    domain: "app.intercom.com",
    path: "northstar / inbox",
  },
  googlesheets: {
    name: "Sheets",
    color: "#0f9d58",
    domain: "docs.google.com",
    path: "spreadsheets / company-work",
  },
  googledrive: {
    name: "Drive",
    color: "#4285f4",
    domain: "drive.google.com",
    path: "northstar / shared-work",
  },
};
